import { collection, query, where, getDocs, limit, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function fetchWorkspacesByClient(clientId, limitCount = 80) {
  const ref = collection(db, ...FS.autosWorkspaces(appId));
  const directSnap = await getDocs(query(ref, where('clientId', '==', clientId), limit(limitCount)));
  const direct = directSnap.docs.map((d) => ({ id: d.id, ...(d.data() || {}) }));

  const sampleSnap = await getDocs(query(ref, limit(200)));
  const sample = sampleSnap.docs
    .map((d) => ({ id: d.id, ...(d.data() || {}) }))
    .filter((w) => {
      const refs = Array.isArray(w?.partiesRefs) ? w.partiesRefs : [];
      return refs.some((p) => {
        if (typeof p === 'string') return String(p || '').trim() === clientId;
        return String(p?.clientId || '').trim() === clientId;
      });
    });

  const merged = new Map();
  [...direct, ...sample].forEach((w) => {
    const wid = String(w?.id || '').trim();
    if (!wid) return;
    merged.set(wid, w);
  });

  const out = Array.from(merged.values());
  out.sort((a, b) => {
    const av = a?.updatedAt?.toDate ? a.updatedAt.toDate().getTime() : 0;
    const bv = b?.updatedAt?.toDate ? b.updatedAt.toDate().getTime() : 0;
    return bv - av;
  });
  return out;
}

export async function createWorkspace(clientId, clientName) {
  const wsCol = collection(db, ...FS.autosWorkspaces(appId));
  const safeName = String(clientName || '').trim();
  const autoAlias = safeName ? `Processo — ${safeName}` : 'Processo';
  const newRef = await addDoc(wsCol, {
    clientId,
    alias: autoAlias,
    name: autoAlias,
    clientNameSnapshot: safeName,
    pieces: [],
    partiesRefs: [clientId],
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return { id: newRef.id, alias: autoAlias };
}
